import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import BookCall from './BookCall';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
import moment from 'moment';

import BigCalendar from 'react-big-calendar';
// a localizer for BigCalendar
BigCalendar.momentLocalizer(moment);

const $= window.$;

class TeleCalender extends Component {
  constructor(props) {
    super(props);
    
        this.state={
          call_id : props.call_id,
          tele_id : props.tele_id,
          events : [],
          open: false,
        };
        
       this.getPopup = this.getPopup.bind(this);
       this.onCloseModal = this.onCloseModal.bind(this);
  }

  onChangeComp(value){
    this.props.ChangedComp(value);
  }
  componentWillReceiveProps(nextProps) {
    
  }

  getPopup(event){
      this.setState({ 
            open: true,
            BookComp : <BookCall events={event} closeModal={this.onCloseModal} ChangeComp={this.onChangeComp.bind(this)}/>
      });     
  }
 
  onCloseModal(){
    this.setState({ open: false });
  };
 
  getEvents(){
      let learner_id = Common.getUserData("id", true);
      let pinid = Common.getUserData("pinID", true);
      let pinno = Common.getUserData("pinNo", true);
      let call_id = this.state.call_id;
      let tele_id = this.state.tele_id;
      fetch(Config.domainUrl+'telecall/get-events', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' +Common.getTokenData()
            },

              body: JSON.stringify({
                learner_id:learner_id,pinid:pinid,pinno:pinno,call_id:call_id,tele_id:tele_id
              })
            }).then((response) => response.json())
           .then((responseJson) => {
            // alert(JSON.stringify(responseJson));
            if(responseJson.status != 0){
                this.setState({
                    events : responseJson.events,
                });
            }
       });
  }

   

    componentDidMount() {
      this.getEvents();
    }




    render() {
      const {open} = this.state;
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      let d=new Date(), jDate=d.getDate(), jMonth=monthNames[d.getMonth()], jYear=d.getFullYear();

      return (
        <div>
          <section id="semana-scroll-inner" className="scroll">
              <section className="viewport">
                  <section style={{top: "0px"}} className="overview">
                      <div className="inner-content">
                        <div className="telecal-reqcalendar">
                          <h2 className="recap-blue-title">E Coach's available slots for telecalls</h2>
                          <p><span></span> - Dates with this color background denotes availability of E Coach</p>
                          <p style={{textAlign:'center'}}>{jMonth+' '+jYear}</p>
                        </div>
                          <BigCalendar
                            popup
                            selectable
                            style={{height: '520px',width:'100%'}}
                            views={['month']} 
                            defaultView='month'
                            toolbar={false}
                            events={this.state.events}
                            onSelectEvent={event => 
                              this.getPopup(event)
                            }
                          />
                      </div>
                      <Modal open={open} onClose={this.onCloseModal} >
                         {this.state.BookComp}
                      </Modal>
                  </section>
              </section>
          </section>
        </div>
      );
    }
}

export default TeleCalender;



// WEBPACK FOOTER //
// ./src/personal_interactions/telecall_request/TeleCalender.js